if (typeof window.SectionCollection === 'undefined') {
  class SectionCollection {
    constructor(root) {
      this.root = root;
      this.panel = root.querySelector('.js-filter-panel');
      this.closeButton = root.querySelector('.js-filter-close');
      this.toggleButtons = root.querySelectorAll('.js-filter-toggle');
      this.grid = root.querySelector('.js-products-grid');
      this.paginationContainer = root.querySelector('.js-pagination');
      this.loadMoreButton = root.querySelector('.js-load-more');
      this.updatePanelHeight = this.updatePanelHeight.bind(this);
      this.bindDrawer();
      this.bindLoadMore();
    }

    updatePanelHeight() {
      if (!this.panel) return;
      const rect = this.panel.getBoundingClientRect();
      const viewportHeight = window.visualViewport ? window.visualViewport.height : window.innerHeight;
      const height = Math.max(0, viewportHeight - rect.top);
      this.panel.style.height = `${height}px`;
    }

    bindDrawer() {
      const setIcons = (isOpen) => {
        for (const btn of this.toggleButtons) {
          const filterIcon = btn.querySelector('.js-icon-filter');
          const closeIcon = btn.querySelector('.js-icon-close');
          if (!filterIcon || !closeIcon) continue;
          if (isOpen) {
            filterIcon.classList.add('hidden');
            closeIcon.classList.remove('hidden');
            btn.setAttribute('aria-expanded', 'true');
          } else {
            closeIcon.classList.add('hidden');
            filterIcon.classList.remove('hidden');
            btn.setAttribute('aria-expanded', 'false');
          }
        }
      };

      const open = () => {
        if (!this.panel) return;
        document.body.classList.add('overflow-hidden');
        this.updatePanelHeight();
        requestAnimationFrame(() => {
          this.panel.classList.remove('translate-x-full');
          this.panel.setAttribute('aria-hidden', 'false');
          setIcons(true);
        });
      };

      const close = () => {
        if (!this.panel) return;
        this.panel.classList.add('translate-x-full');
        setIcons(false);
        document.body.classList.remove('overflow-hidden');
        this.panel.setAttribute('aria-hidden', 'true');
        this.panel.addEventListener('transitionend', () => {
        }, { once: true });
      };

      const toggle = () => {
        if (!this.panel) return;
        const isClosed = this.panel.classList.contains('translate-x-full');
        if (isClosed) {
          open();
        } else {
          close();
        }
      };

      setIcons(false);
      this.updatePanelHeight();
      if (this.panel) this.panel.setAttribute('aria-hidden', 'true');

      window.addEventListener('resize', this.updatePanelHeight);
      if (window.visualViewport) window.visualViewport.addEventListener('resize', this.updatePanelHeight);

      for (const btn of this.toggleButtons) btn.addEventListener('click', toggle);
      this.closeButton?.addEventListener('click', close);
    }

    bindLoadMore() {
      if (!this.loadMoreButton || !this.grid) return;

      const parseNextUrlFromHTML = (htmlText) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlText, 'text/html');
        const nextButton = doc.querySelector('.js-load-more');
        return nextButton ? nextButton.getAttribute('data-next-url') : null;
      };

      const extractNewItemsHTML = (htmlText) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlText, 'text/html');
        const newGrid = doc.querySelector('.js-products-grid');
        return newGrid ? newGrid.innerHTML : '';
      };

      const onClick = async () => {
        const nextUrl = this.loadMoreButton.getAttribute('data-next-url');
        if (!nextUrl) return;

        const originalText = this.loadMoreButton.textContent;
        const loadingText = this.loadMoreButton.getAttribute('data-loading-text') || 'Loading…';
        this.loadMoreButton.textContent = loadingText;
        this.loadMoreButton.disabled = true;

        try {
          const response = await fetch(nextUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
          if (!response.ok) throw new Error('Network error');
          const htmlText = await response.text();

          const itemsHTML = extractNewItemsHTML(htmlText);
          if (itemsHTML) this.grid.insertAdjacentHTML('beforeend', itemsHTML);

          const newNext = parseNextUrlFromHTML(htmlText);
          if (newNext) {
            this.loadMoreButton.setAttribute('data-next-url', newNext);
            this.loadMoreButton.textContent = originalText;
            this.loadMoreButton.disabled = false;
          } else {
            this.loadMoreButton.remove();
          }
        } catch (e) {
          this.loadMoreButton.textContent = originalText;
          this.loadMoreButton.disabled = false;
        }
      };

      this.loadMoreButton.addEventListener('click', onClick);
    }
  }

  window.SectionCollection = SectionCollection;
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.js-collection-section').forEach((root) => {
    new window.SectionCollection(root);
  });
});